export default __webpack_public_path__ + "static/media/college.a8ca9bd6.jpg";